import { Box } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CheckboxGroupField from 'components/forms/fields/checkbox-group-field/checkbox-group-field.component';
import DaysMultipleSelectField from 'components/forms/fields/days-multiple-select-field/days-multiple-select-field.component';
import { useLocationHoursContext } from 'components/location-hours/location-hours.context';
import { filterNormalHoursOverlappedEvents } from 'components/location-hours/normal-hours-calendar/normal-hours.utils';
import TimeRangePickerField from 'components/forms/fields/time-range-picker-field/time-range-picker-field.component';

type SetNormalHoursFormProps = {
  eventId: string;
};
const SetNormalHoursForm = ({ eventId }: SetNormalHoursFormProps) => {
  const { t } = useTranslation();
  const orderType = useWatch({ name: 'orderType' });
  const daysOfWeek = useWatch({ name: 'daysOfWeek' });
  const timeRange = useWatch({ name: 'timeRange' });
  const {
    normalHours: { normalEvents },
  } = useLocationHoursContext();

  const orderTypeOptions = [
    {
      label: t('forms.setNormalHoursForm.fields.orderType.options.pickup'),
      id: 'PICKUP',
    },
    {
      label: t('forms.setNormalHoursForm.fields.orderType.options.delivery'),
      id: 'DELIVERY',
    },
  ];

  const hasOverlap =
    filterNormalHoursOverlappedEvents(
      { eventId, orderType, daysOfWeek, timeRange },
      normalEvents,
    ).length > 0;

  return (
    <Box className="field-container" display="grid" gap={3}>
      <CheckboxGroupField
        name="orderType"
        options={orderTypeOptions}
        FormGroupProps={{
          sx: {
            flexDirection: 'row',
          },
        }}
      />

      <DaysMultipleSelectField
        name="daysOfWeek"
        label={t('forms.setNormalHoursForm.fields.daysOfWeek.label')}
        data-testid="SetNormalHoursForm.DaysOfWeek.Field"
        TextFieldProps={{ margin: 'none' }}
      />

      <TimeRangePickerField
        name="timeRange"
        helperText={
          hasOverlap &&
          t('forms.setNormalHoursForm.fields.timeRange.warnings.overlap')
        }
        helperTextSeverity="warning"
        minutesStep={15}
        fromLabel={t('forms.setNormalHoursForm.fields.timeRange.fromLabel')}
        toLabel={t('forms.setNormalHoursForm.fields.timeRange.toLabel')}
        data-testid="SetNormalHoursForm.TimeRange.Field"
      />
    </Box>
  );
};

export default SetNormalHoursForm;
